import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgTrash({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a4.002 4.002 0 013.874 3H21a1 1 0 110 2v12a3 3 0 01-3 3H6a3 3 0 01-3-3V7a1 1 0 010-2h5.126C8.57 3.275 10.136 2 12 2zm7 5H5v12a1 1 0 001 1h12a1 1 0 001-1V7zM9 10a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1zm6 0a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1zm-3-6a2 2 0 00-1.732 1h3.464A2 2 0 0012 4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgTrash
